import { render, staticRenderFns } from "./AdditionalResources.vue?vue&type=template&id=ecb3c86c&"
import script from "./AdditionalResources.vue?vue&type=script&lang=js&"
export * from "./AdditionalResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecb3c86c')) {
      api.createRecord('ecb3c86c', component.options)
    } else {
      api.reload('ecb3c86c', component.options)
    }
    module.hot.accept("./AdditionalResources.vue?vue&type=template&id=ecb3c86c&", function () {
      api.rerender('ecb3c86c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/AdditionalResources/AdditionalResources.vue"
export default component.exports